import React from 'react';
import { Notice } from '../insurance/formBits';

// The validator's verdict: every blocking error at once, then warnings.
export default function ValidationPanel({ validation }) {
  if (!validation) return null;
  const { errors = [], warnings = [] } = validation;
  return (
    <div>
      {errors.length === 0
        ? <Notice tone="good">Passes every check{warnings.length ? ' (with warnings below)' : ''}.</Notice>
        : (
          <Notice tone="bad">
            <strong>{errors.length} {errors.length === 1 ? 'thing' : 'things'} to fix before this claim can go out</strong>
            <ul style={{ margin: '6px 0 0 18px', padding: 0 }}>{errors.map((e, i) => <li key={i}>{e.message}</li>)}</ul>
          </Notice>
        )}
      {warnings.length > 0 && (
        <div style={{ marginTop: 8 }}>
          <Notice tone="warn"><ul style={{ margin: 0, paddingLeft: 18 }}>{warnings.map((w, i) => <li key={i}>{w.message}</li>)}</ul></Notice>
        </div>
      )}
    </div>
  );
}
